import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f8212446")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "p-col-12" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModuleHeader = _resolveComponent("ModuleHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Center = _resolveComponent("Center")!
  const _component_ReferralsTable = _resolveComponent("ReferralsTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModuleHeader, {
      title: "Programa de referidos",
      showGoBack: false
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            disabled: _ctx.loading,
            placeholder: "Buscar por cupón",
            modelValue: _ctx.searchTxt,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchTxt = $event))
          }, null, 8, ["disabled", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Center, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_BrainSpinner)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_ReferralsTable, {
              key: 1,
              referrals: (_ctx.dataReferral as _ctx.referral[]),
              totalRecords: _ctx.totalRecords,
              recordsLimit: _ctx.recordsLimit,
              firstRow: _ctx.firstRegister,
              order: _ctx.order,
              page: _ctx.page,
              onUpdateReferral: _ctx.updateReferral,
              onOnChangeRowsPerPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeRowsPerPage($event))),
              onOnPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
              onOnSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSort($event)))
            }, null, 8, ["referrals", "totalRecords", "recordsLimit", "firstRow", "order", "page", "onUpdateReferral"]))
      ])
    ])
  ], 64))
}